import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { verifyTokenValidity } from "../../write/application/use-cases/token-verification/verify-token-validity";
import { activateAccount } from "../../write/application/use-cases/account-activation/activate-account";
import { selectTokenValidityCheck } from "@user-management-context/write/application/use-cases/token-verification/selectors/token-validity-selectors";
import { AccountActivation } from "./account-activation.content";
import { useAccountActivation } from "./use-account-activation";
import type { AccountActivationFormInputs } from "./form-validation/account-activation.schema";
import { accountActivationFormatFormDataToBodyData } from "./form-validation/account-activation.schema";

interface Props {
  userId: string;
  token: string;
}

export const AccountActivationContainer = ({ userId, token }: Props) => {
  const dispatch = useAppDispatch();

  const { data: tokenFromDB } = useAppSelector(selectTokenValidityCheck);
  const tokenStatus = tokenFromDB?.status ?? "valid";
  const user = tokenFromDB?.user ?? null;

  useEffect(() => {
    dispatch(verifyTokenValidity({ userId, token }));
  }, [dispatch, token, userId]);

  useAccountActivation();

  const handleOnSubmit = async (formBody: AccountActivationFormInputs) => {
    const body = accountActivationFormatFormDataToBodyData(formBody, userId, token);
    await dispatch(activateAccount(body));
  };

  return <AccountActivation tokenStatus={tokenStatus} user={user} onSubmit={handleOnSubmit} />;
};
